import { connect } from 'react-redux'
import { getAuth, getLoginUserAdmin } from '../../state/Auth/selectors'
import { Admin, Auth, User } from '../../types'
import { State } from '../../types/state'
import NavBar from './components/NavBar'

type SProps = {
  auth: Auth
  user: User | Admin | null
}

type OProps = {
  title?: string
}
type DProps = {}

const conn = connect<SProps, DProps, OProps, State>(
  (state) => ({
    auth: getAuth(state),
    user: getLoginUserAdmin(state),
  }),
  {},
)

export default conn(NavBar)
